<template>
  <v-nav>
    <div style="width: 100%;margin-top: 20px">
      <h2 style="font-weight: bold;color: white">团队负责人</h2>
      <a-row :gutter="32">
        <a-col :span="12">
          <a-row style="background-color: white">
            <a-col :span="10" style="width: 100%">
              <img src="../../../assets/contact/cuizaixu.jpg" style="width: 100%;"/>
            </a-col>
            <a-col :span="14">
              <div class="professor-bk" style="">
                <h2 style="font-weight: bold">崔再续</h2>
                <div>北京天坛医院神经外科神经肿瘤四病区副主任</div>
                <div>博士生导师</div>
              </div>
              <div style="padding: 16px 16px 16px 20px;margin-top: 150px">
                <div>
                  国家神经系统疾病临床医学研究中心PI，北京脑科学与类脑研究中心双聘研究员。入选北京市科技新星计划项目，北脑青年学者。
                </div>
                <div>
                  作为共同执笔人参编国家卫健委《脑胶质瘤诊疗规范（2018年版）》及《脑胶质瘤诊疗指南（2022年版）》。成果获2020年华夏医学科技奖
                  一等奖（3/15）。获2021年全国脑胶质瘤手术比赛总决赛冠军。
                </div>
              </div>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row style="background-color: white">
            <a-col :span="10" style="width: 100%">
              <img src="../../../assets/contact/cuizaixu.jpg" style="width: 100%;"/>
            </a-col>
            <a-col :span="14">
              <div class="professor-bk" style="">
                <h2 style="font-weight: bold">崔再续</h2>
                <div>北京天坛医院神经外科神经肿瘤四病区副主任</div>
                <div>博士生导师</div>
              </div>
              <div style="padding: 16px 16px 16px 20px;margin-top: 150px">
                <div>
                  国家神经系统疾病临床医学研究中心PI，北京脑科学与类脑研究中心双聘研究员。入选北京市科技新星计划项目，北脑青年学者。
                </div>
                <div>
                  作为共同执笔人参编国家卫健委《脑胶质瘤诊疗规范（2018年版）》及《脑胶质瘤诊疗指南（2022年版）》。成果获2020年华夏医学科技奖
                  一等奖（3/15）。获2021年全国脑胶质瘤手术比赛总决赛冠军。
                </div>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>

      <h2 style="font-weight: bhuold;color: white;margin-top: 50px">团队成员</h2>
      <div style="width: 100%;">
        <div style="padding: 16px 16px;width: 20%;display: inline-block">
          <img src="../../../assets/contact/zhouhan.png" style="width: 100%"/>
          <div class="member-desc">
            <h3 style="font-weight: bold;color: white">周晗</h3>
            <div style="font-size: 12px">web全栈开发工程师</div>
            <div style="font-size: 12px">北京脑科学与类脑研究中心</div>
          </div>
        </div>
        <div style="padding: 16px 16px;width: 20%;display: inline-block">
          <img src="../../../assets/contact/zhouhan.png" style="width: 100%"/>
          <div class="member-desc">
            <h3 style="font-weight: bold;color: white">周晗</h3>
            <div style="font-size: 12px">web全栈开发工程师</div>
            <div style="font-size: 12px">北京脑科学与类脑研究中心</div>
          </div>
        </div>
        <div style="padding: 16px 16px;width: 20%;display: inline-block">
          <img src="../../../assets/contact/zhouhan.png" style="width: 100%"/>
          <div class="member-desc">
            <h3 style="font-weight: bold;color: white">周晗</h3>
            <div style="font-size: 12px">web全栈开发工程师</div>
            <div style="font-size: 12px">北京脑科学与类脑研究中心</div>
          </div>
        </div>
        <div style="padding: 16px 16px;width: 20%;display: inline-block">
          <img src="../../../assets/contact/zhouhan.png" style="width: 100%"/>
          <div class="member-desc">
            <h3 style="font-weight: bold;color: white">周晗</h3>
            <div style="font-size: 12px">web全栈开发工程师</div>
            <div style="font-size: 12px">北京脑科学与类脑研究中心</div>
          </div>
        </div>
        <div style="padding: 16px 16px;width: 20%;display: inline-block">
          <img src="../../../assets/contact/zhouhan.png" style="width: 100%"/>
          <div class="member-desc">
            <h3 style="font-weight: bold;color: white">周晗</h3>
            <div style="font-size: 12px">web全栈开发工程师</div>
            <div style="font-size: 12px">北京脑科学与类脑研究中心</div>
          </div>
        </div>
      </div>
    </div>
  </v-nav>
</template>

<script>
import VNav from "@/components/public/VNav.vue";

export default {
  name: "aboutPage",
  components: {VNav}
}
</script>

<style scoped>
.professor-bk {
  position: absolute;
  top: 30px;
  left: -20px;
  background: inherit;
  height: 120px;
  width: 350px;
  overflow: hidden;
  border-radius: 5px;
  padding: 20px 20px 20px 40px;
  color: black;
  background-color: rgba(234, 231, 231, 0.5);
  backdrop-filter: blur(5px)
}

.member-desc{
  position: relative;
  left: 0;
  bottom: 120px;
  height: 100px;
  padding: 16px 16px;
  background: inherit;
  width: 80%;
  border-radius: 5px;
  background-color: rgba(234, 231, 231, 0.1);
  backdrop-filter: blur(5px);
  color : white;
}
</style>